import type { DanceSeoHead } from "../danceSeoTypes.js";

// pl translation of the English source (shared/danceSeoHeads/en.ts); numbers and limits must stay in sync with it.
const head: DanceSeoHead = {
  director: {
    title: "Generator wideo tanecznych AI z muzyki – zacznij za darmo",
    description:
      "Zamień piosenkę w pełne wideo taneczne AI. Solmi planuje choreografię każdej sekcji, tworzy storyboard i renderuje ujęcia tańca i lip-sync. Zacznij za darmo.",
    h1: "Generator wideo tanecznych AI – zamień każdą piosenkę w wideo taneczne",
  },
  photo: {
    title: "Niech zdjęcie zatańczy – generator tańca AI ze zdjęcia",
    description:
      "Niech zdjęcie zatańczy z AI: prześlij zdjęcie w całej postaci, wybierz ruch lub własny klip, dodaj piosenkę. Solmi zgra taniec z rytmem. Zacznij za darmo.",
    h1: "Niech zdjęcie zatańczy – generator tańca AI ze zdjęcia",
  },
  inbound:
    "Chcesz, żeby wykonawca tańczył? [Generator wideo tanecznych AI](/ai-dance-video-generator) planuje choreografię dla każdej sekcji piosenki i renderuje pełne wideo taneczne.",
};

export default head;
